/** Credit-note helpers shared by the expense table, add form, and amount filters. */

export function isCreditDocumentType(documentType: unknown): boolean {
  return String(documentType ?? '').trim().toLowerCase() === 'credit_note';
}

export function matchesCreditFilter(isCredit: boolean | undefined, creditsOnly: boolean): boolean {
  return !creditsOnly || Boolean(isCredit);
}

/** When filtering credits only, compare min/max against the absolute stored amount. */
export function amountForFilter(amount: number | undefined | null, creditsOnly: boolean): number {
  const value = Number(amount || 0);
  return creditsOnly ? Math.abs(value) : value;
}

export function looksLikeCreditAmounts(
  ...amounts: Array<number | null | undefined>
): boolean {
  return amounts.some((value) => value != null && Number.isFinite(Number(value)) && Number(value) < 0);
}

const toNegative = (value: number | null | undefined): number => {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return -Math.abs(num);
};

/** Force net / VAT / total negative for a credit without double-negating. */
export function applyCreditSignToAmounts(
  net: number,
  vat: number | null | undefined,
  total: number
): { netAmount: number; vatAmount: number; totalAmount: number } {
  return {
    netAmount: toNegative(net),
    vatAmount: vat == null ? 0 : toNegative(vat),
    totalAmount: toNegative(total),
  };
}
